// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__1-mKL","item":"Breadcrumb_item__2FtT4","pulse":"Breadcrumb_pulse__3mdg5"};